module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bio-page"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Tous les personnages")]), _vm._v(" "), _c('div', {
    staticClass: "bio-page__group"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Les joueurs")]), _vm._v(" "), _c('div', {
    staticClass: "bio-page__group-container"
  }, _vm._l((_vm.getCharactersData), function(character, i) {
    return _c('div', {
      staticClass: "bio-page__character",
      attrs: {
        "data-type": "character",
        "data-id": i
      },
      on: {
        "click": _vm.openPopinInfos
      }
    }, [_c('img', {
      attrs: {
        "src": character.img,
        "alt": "character.name"
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(character.name))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "bio-page__group"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Les protagonistes")]), _vm._v(" "), _c('div', {
    staticClass: "bio-page__group-container"
  }, _vm._l((_vm.getQuestionsData), function(person, i) {
    return _c('div', {
      staticClass: "bio-page__character bio-page__character--all",
      attrs: {
        "data-type": "person",
        "data-id": i
      },
      on: {
        "click": _vm.openPopinInfos
      }
    }, [_c('img', {
      attrs: {
        "src": ("http://transfertsdepekin.fr/assets/questions/" + (person.characterImg)),
        "alt": "person.name"
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(person.character))])])
  }))]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeIn"
    }
  }, [(_vm.getShowPopin) ? _c('popin-infos', {
    attrs: {
      "params": _vm.popinParams
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34d3a100"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bio.vue
// module id = 83
// module chunks = 0